<template>
  <div>
    <div class="vx-row mx-2">
      <div class="router-header flex flex-wrap items-center mb-6">
        <div
          class="
            content-area__heading
            pr-4
            border-0
            md:border-r
            border-solid border-grey-light
          "
        >
          <a href="#" @click="$router.push('/users')"><h2 class="mb-1">ทีมเจ้าหน้าที่ทางเทคนิค</h2></a>
        </div>
        <!-- <p class="mx-5 mt-2">เพิ่มทีม</p> -->
      </div>
    </div>
    <div class="p-4">
      <vx-card class="p-5">
        <!-- <vs-button
          class="mb-2"
          color="primary"
          type="gradient"
          icon-pack="feather"
          icon="icon-plus"
        >
          เพิ่มทีม
        </vs-button> -->

        <vs-table
        :data="teams"
        max-items="10"
        class="text-center"
      >
        <template slot="thead">
          <vs-th><p class="mx-auto">ลำดับ</p></vs-th>
          <vs-th><p class="mx-auto">ชื่อย่อทีม</p></vs-th>
          <vs-th><p class="mx-auto">ชื่อทีม</p></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="indextr">
              {{ indextr + 1 }}
            </vs-td>
            <vs-td :data="data[indextr].initial">
              {{ data[indextr].initial }}
            </vs-td>

            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
      </vx-card>
    </div>
  </div>
</template>

<script>

import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Swal from "sweetalert2";

import { Validator } from "vee-validate";
import { DICT_VESSEL, DICT_USER } from "../../../mock-data/form-validate.js";
// register custom messages
Validator.localize("en", DICT_VESSEL, DICT_USER);


export default {
  name: "",
  components: {
    FormWizard,
    TabContent,
  },
  props: {
    isSuperVisor: false,
    isObserver: false,
  },
  data() {
    return {
      teams: [],
      userRole: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      await this.$store.dispatch("users/getTeam");
      this.teams = this.$store.state.users.teams;
      console.log("this is teams data ===> ", this.teams);
    },
  },
};
</script>
<style lang="css" scoped>
.box {
  padding: 10px 10px 10px 10px;
  width: 400px;
  height: 250px;
  border-style: dotted;
  border-color: #0984e3;
}
.img-show {
  width: 100%;
  height: 225px;
}
</style>